import _toConsumableArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
/* eslint-disable no-useless-escape */
/* eslint-disable no-prototype-builtins */
// import { GET_DEPT_ROOT, GET_DEPT_TREE, GET_USER_BY_DEPT, GET_PAGE_EMPLOYEE } from "@/api"

var GET_DEPT_ROOT = {
  code: 200,
  msg: "获取成功",
  data: {
    deptId: 1,
    deptName: "xxx公司"
  }
};
var GET_DEPT_TREE = {
  code: 200,
  msg: "获取成功",
  data: [{
    deptId: 2,
    deptName: "xxx财务部",
    parentDeptId: 1
  }, {
    deptId: 3,
    deptName: "xxx行政部",
    parentDeptId: 1
  }, {
    deptId: 4,
    deptName: "xxx研发部",
    parentDeptId: 1
  }, {
    deptId: 5,
    deptName: "xxx工程部",
    parentDeptId: 1
  }, {
    deptId: 6,
    deptName: "xxx后勤部",
    parentDeptId: 1
  }]
};
// eslint-disable-next-line no-unused-vars
var GET_USER_BY_DEPT = {
  code: 200,
  msg: "获取成功",
  data: [{
    userId: 20,
    userName: "张三",
    deptId: 1
  }, {
    userId: 30,
    userName: "李四",
    deptId: 1
  }, {
    userId: 40,
    userName: "王五",
    deptId: 1
  }, {
    userId: 50,
    userName: "二麻子",
    deptId: 1
  }, {
    userId: 60,
    userName: "富贵",
    deptId: 1
  }]
};
var GET_PAGE_EMPLOYEE = GET_USER_BY_DEPT;
// eslint-disable-next-line no-unused-vars
var toHump = function toHump(name) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
};
// 需要自行设置nodeID  重要！！！
function getDepChildNode(_x) {
  return _getDepChildNode.apply(this, arguments);
} // 需要返回一个promise
function _getDepChildNode() {
  _getDepChildNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(orgId) {
    var promises, res, nodes;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          promises = [GET_DEPT_TREE({
            orgId: orgId
          })];
          res = []; // loadUser && promises.push( GET_USER_BY_DEPT( { deptId: orgId } ) )
          _context2.prev = 2;
          _context2.next = 5;
          return Promise.all(promises);
        case 5:
          res = _context2.sent;
          _context2.next = 10;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](2);
        case 10:
          nodes = res.reduce(function (p, c) {
            return [].concat(_toConsumableArray(p), _toConsumableArray(c.data));
          }, []);
          return _context2.abrupt("return", nodes);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 8]]);
  }));
  return _getDepChildNode.apply(this, arguments);
}
function loadDepOrUser(_x2) {
  return _loadDepOrUser.apply(this, arguments);
} // 获取组织结构根节点
// 需要自行设置nodeID  重要！！！
function _loadDepOrUser() {
  _loadDepOrUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(node) {
    var loadDep,
      nodeData,
      test,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          loadDep = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
          nodeData = [];
          if (!(node.level === 0)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 5;
          return getRootDept();
        case 5:
          test = _context3.sent;
          // 获取根节点
          nodeData = [test];
          _context3.next = 16;
          break;
        case 9:
          if (!(node.level === 1)) {
            _context3.next = 15;
            break;
          }
          _context3.next = 12;
          return getDepChildNode(node.data.deptId);
        case 12:
          nodeData = _context3.sent;
          _context3.next = 16;
          break;
        case 15:
          if (!loadDep && node.level === 2) {
            nodeData = GET_PAGE_EMPLOYEE.data; // 获取部门下人员
          }
        case 16:
          return _context3.abrupt("return", nodeData);
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _loadDepOrUser.apply(this, arguments);
}
function getRootDept() {
  return _getRootDept.apply(this, arguments);
}
function _getRootDept() {
  _getRootDept = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var res;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          res = [];
          _context4.prev = 1;
          _context4.next = 4;
          return GET_DEPT_ROOT();
        case 4:
          res = _context4.sent.data;
          _context4.next = 9;
          break;
        case 7:
          _context4.prev = 7;
          _context4.t0 = _context4["catch"](1);
        case 9:
          return _context4.abrupt("return", res);
        case 10:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 7]]);
  }));
  return _getRootDept.apply(this, arguments);
}
function loadDepData(node) {
  return loadDepOrUser(node); // 返回的promise
}

function loadUserData(node) {
  return loadDepOrUser(node, false); // 返回的promise
}

var defaultOption = {
  tabName: "部门",
  // 选项卡名称
  tabKey: "dep",
  // 选项卡键值 传入的selected要和键值保持一致 eg: {dep: [], role: []}
  children: "children",
  // 子节点标志
  // 生成每个节点的id 保证唯一
  nodeId: function nodeId(data) {
    return data.hasOwnProperty("userId") ? data.userId : data.deptId;
  },
  // 生成节点的名称 可选值 string | function
  label: function label(data, node) {
    return data.hasOwnProperty("userId") ? data.userName : data.deptName;
  },
  // 判断是否为叶子节点 可选值 string | function
  isLeaf: function isLeaf(data, node) {
    return data.hasOwnProperty("userId"); // 含有empID为人员  且为叶子节点
  },

  // 搜索后的结果如果需要展示一些提示文字 例如搜索人员 提示人员所属部门  可以使用该属性
  // function
  searchResTip: function searchResTip(data) {
    return "部门：" + data.deptId;
  },
  // 判断该节点是否可选 例如同时选择部门和部门下的人
  disabled: function disabled(data, node) {
    return false;
  },
  // 动态请求后台拿到节点数据 返回一个promise
  onload: loadDepData,
  // 搜索节点方法
  onsearch: function () {
    var _onsearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(searchString, resolve, reject) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // const param = { page: 1, limit: 200, searchName: searchString }
            resolve(GET_PAGE_EMPLOYEE.data);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function onsearch(_x3, _x4, _x5) {
      return _onsearch.apply(this, arguments);
    }
    return onsearch;
  }()
};
export var DEP_CONFIG = Object.assign({}, defaultOption);
export var ROLE_CONFIG = Object.assign({}, defaultOption, {
  tabKey: "role",
  tabName: "角色"
});
export var USER_CONFIG = Object.assign({}, defaultOption, {
  tabKey: "user",
  tabName: "指定人员",
  onload: loadUserData,
  disabled: function disabled(data, node) {
    return !data.hasOwnProperty("userId");
  }
});
var DEP_USER_CONFIG = Object.assign({}, defaultOption, {
  tabKey: "dep&user",
  tabName: "部门和人员",
  onload: loadUserData,
  disabled: function disabled() {
    return false;
  }
});
var POSITION_CONFIG = Object.assign({}, defaultOption, {
  tabKey: "position",
  tabName: "岗位"
});
export var CONFIG_LIST = [DEP_CONFIG, ROLE_CONFIG, USER_CONFIG, DEP_USER_CONFIG, POSITION_CONFIG];